import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User, LogOut, Settings } from "lucide-react";
import { User as UserType } from "@supabase/supabase-js";
import { EnhancedUserMenu } from "./EnhancedUserMenu";

interface UserMenuProps {
  user: UserType;
  userRole: string | null;
  onSignOut: () => void;
  getDashboardLink: () => string;
}

export function UserMenu({
  user,
  userRole,
  onSignOut,
  getDashboardLink,
}: UserMenuProps) {
  // Use the enhanced version for better UX
  return (
    <EnhancedUserMenu
      user={user}
      userRole={userRole}
      onSignOut={onSignOut}
      getDashboardLink={getDashboardLink}
    />
  );
}
